export const reportDataDebsOrders = {
  data: {
    rpp: '/COROTA/MediDebtByPat',  // Or '/COROTA/MediDebtCons'
    pts: 1,
    fr: true,
    dn: '',
    rp: '',
  },
  dataDownloadPDF: {
    rpp: '/COROTA/MediDebtByPat', // Or '/COROTA/MediDebtCons'
    pts: 0,
    fmt: 2,
    dn: '',
    rp: '',
  },
  dataDownloadExcel: {
    rpp: '/COROTA/MediDebtByPat', // Or '/COROTA/MediDebtCons'
    pts: 0,
    fmt: 3,
    dn: '',
    rp: '',
  },
  dataRenderReport: {
    rpp: '/COROTA/MediDebtByPat', // Or '/COROTA/MediDebtCons'
    pts: 0,
    z: 100,
    htmf: false,
    fmt: 2,
    dl: false,
    dn: '',
    rp: '',
  },
};
